import { render, staticRenderFns } from "./JapanFilersView.vue?vue&type=template&id=dafd8ab0&scoped=true&"
import script from "./JapanFilersView.vue?vue&type=script&lang=ts&"
export * from "./JapanFilersView.vue?vue&type=script&lang=ts&"
import style0 from "./JapanFilersView.vue?vue&type=style&index=0&id=dafd8ab0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd8ab0",
  null
  
)

export default component.exports